import React from 'react'

export default function BlueeditIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path d="M1 8.5V2.07143C1 1.4797 1.4797 1 2.07143 1H14.9286C15.5203 1 16 1.4797 16 2.07143V14.9286C16 15.5203 15.5203 16 14.9286 16H8.5M4.33333 8.5H8.5M8.5 8.5V12.6667M8.5 8.5L1 16" stroke="#111AE9" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
